import { Utility } from '@core/app/scripts/services/utility';

export class Validation {
  constructor(private utility: Utility) {}

  correct = (string, type, options) => {
    if (typeof string !== 'string') {
      string = String(string);
    }
    if (type == 'key') {
      string = string.replace(' ', '_');
      //only alpha-numeric and _-
      string = string.replace(/[^A-Za-z0-9_-]/g, '');
      //don't start with a number
      string = string.replace(/^[0-9-]/, '');
      return string;
    }
    if (type == 'json') {
      try {
        const j = JSON.parse(string);
        return j && typeof j === 'object';
      } catch (e) {
        return false;
      }
    }
    if (!options) {
      options = {};
    }
    if (type == 'integer' || type == 'int') {
      string = string.replace(',', '.');
      string = string.replace(/[^0-9.-]/g, '');
      let i = Number(string);
      if (string === '') {
        i = 0;
      }
      i = Math.round(i);
      if (isNaN(i)) {
        i = 0;
      }
      if ((options.gte || options.gte === 0) && options.gte > i) {
        i = 0;
        if (options.gte > 0) {
          i = options.gte;
        }
      }
      if ((options.lte || options.lte === 0) && options.lte < i) {
        i = 0;
        if (options.lte < 0) {
          i = options.lte;
        }
      }
      if (options.int) {
        return i;
      }
      return String(i);
    }

    if (type == 'fixed') {
      string = string.replace(',', '.');
      string = string.replace(/[^0-9.-]/g, '');
      //- (-0)
      let m = '',
        s;

      if (string[0] == '-') {
        m = '-';
      }

      if (!options.dot) {
        //. .0 .00
        s = string.match(/\.0*$/);
        if (s === null) {
          //.N0
          s = string.match(/\.\d0/);
          if (s === null) {
            s = '';
          } else {
            s = '0';
          }
        } else {
          s = s[0].substring(0, 3);
        }
      }

      let f = parseFloat(string);
      if (string === '') {
        f = 0;
      }

      if (isNaN(f)) {
        f = 0;
      }

      if ((options.gte || options.gte === 0) && options.gte > f) {
        f = 0;
        if (options.gte > 0) {
          f = options.gte;
        }
      }
      if ((options.lte || options.lte === 0) && options.lte < f) {
        f = 0;
        if (options.lte < 0) {
          f = options.lte;
        }
      }

      f = this.utility.round2(f);
      if (options.float) {
        return f;
      }

      if (f === 0) {
        // @ts-ignore
        f = m + f;
      } else {
        // @ts-ignore
        f = String(f);
      }

      if (options.dot) {
        // @ts-ignore
        const dot = f.indexOf('.');

        if (dot == -1) {
          // @ts-ignore
          f += '.00';
        } else if (dot == s.length - 2) {
          // @ts-ignore
          f += '0';
        } else if (dot == s.length - 3) {
          // @ts-ignore
          f += '00';
        }
        return f;
      }

      return f + s;
    }
    return string;
  };

  validate = (string, type, options) => {
    return this.correct(string, type, options) == string;
  };
}

angular.module('v6CoreModule').service('validation', (utility: Utility) => {
  return new Validation(utility);
});
